import { Heading, Text } from '@rtkwlf/c3-core-react';
import './widget-empty.css';

type WidgetEmptyComponentProps = React.ComponentPropsWithoutRef<'div'>;

type WidgetEmptyProps = {
  /**
   * rendered html attributes of div
   *
   * @default undefined
   */
  attributes?: WidgetEmptyComponentProps;

  /**
   * component className
   *
   * @default undefined
   */
  className?: string;

  /**
   * description of the widget. Falls below the heading
   */
  description: React.ReactNode;

  /**
   *  heading of the widget. Falls below the icon
   */
  heading: React.ReactNode;

  /**
   * title of the widget
   */
  icon: React.ReactNode;
};

const WidgetEmpty: React.FunctionComponent<WidgetEmptyProps> = ({
  attributes,
  className,
  description,
  heading,
  icon,
  ...rest
}) => {
  return (
    <div {...attributes} {...rest} c3-widget-empty="" className={className}>
      {icon}
      <Heading as="h3" align="center" size="3">
        {heading}
      </Heading>
      <Text as="div" align="center" contrast="medium" size="2">
        {description}
      </Text>
    </div>
  );
};

WidgetEmpty.displayName = 'WidgetEmpty';

export { WidgetEmpty };
export type { WidgetEmptyProps };
